import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import {
  FLOW_PARAMETER,
  LABEL_CLASS_PARAMETER,
  MANUAL_REVIEW_FLOW,
  REVIEW_PARAMETER,
  REVIEW_TAB_PARAMETER,
  SEED_PARAMETER,
} from "../../helpers/constants/miscellaneous";

export const useClearLabelPropagationSearchParams = () => {
  const navigate = useNavigate();
  return useCallback(() => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(LABEL_CLASS_PARAMETER);
    searchParams.delete(REVIEW_PARAMETER);
    searchParams.delete(FLOW_PARAMETER);
    searchParams.delete(SEED_PARAMETER);
    searchParams.delete(REVIEW_TAB_PARAMETER);
    searchParams.delete(MANUAL_REVIEW_FLOW);
    navigate({ search: searchParams.toString() });
  }, [navigate]);
};
